module.exports = __webpack_public_path__ + "img/new_home_head.adf955c6.png";